import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'g10-request-form-preview',
  templateUrl: './request-form-preview.component.html',
  styleUrls: ['./request-form-preview.component.css']
})
export class RequestFormPreviewComponent implements OnInit, OnChanges {

  @Input() modalName;
  @Input() popup:boolean = true;
  @Input() requestTitle;
  @Input() requestNote;
  @Input() formPreviewFields;
  @Input() responseData: any = {};
  @Output() closeEvent:any= new EventEmitter();
  public routePreviewForm: FormGroup;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.initializeRoutePreviewForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.formPreviewFields || changes.responseData || changes.requestTitle || changes.modalName) {
      this.initializeRoutePreviewForm();
    }
  }

  closePopup(){
    this.closeEvent.emit(true);
  }

  submitted(e){
    // console.log(e);
  }

  getPreviewSubtitle() {
    const parts = [];
    if (this.responseData?.empName) parts.push(this.responseData.empName);
    if (this.responseData?.empRefID) parts.push(this.responseData.empRefID);
    if (this.responseData?.reqStatus !== undefined && this.responseData?.reqStatus !== null) {
      parts.push(this.getStatusLabel(this.responseData.reqStatus));
    }
    return parts.join('  |  ');
  }

  getFieldClass(field: any) {
    if (!field) return 'col-md-6 col-sm-12 mb-3';
    if (this.isRouteLocationChangePreview()) return 'col-md-12 col-sm-12 mb-3';
    if (field.multiline || field.type === 'map') return 'col-md-12 col-sm-12 mb-3';
    if (field.type === 'multipleDate') return 'col-md-12 col-sm-12 mb-3';
    return 'col-md-6 col-sm-12 mb-3';
  }

  isTextareaField(field: any) {
    if (!field) return false;
    return !!field.multiline || field.type === 'map' || ['message', 'address', 'location'].includes(field.name);
  }

  getFieldValue(field: any) {
    if (!field) return '';
    const value = field.value;

    if (value === null || value === undefined || value === '') return '';

    if (Array.isArray(value)) {
      const mapped = value
        .map((item) => {
          if (item === null || item === undefined || item === '') return null;
          if (typeof item === 'object') return item.name || item.value || JSON.stringify(item);
          return String(item);
        })
        .filter(Boolean);
      return mapped.length > 0 ? mapped.join(', ') : '';
    }

    if (typeof value === 'object') {
      if (value.name) return value.name;
      if (value.lat !== undefined && value.lng !== undefined) return `${value.lat}, ${value.lng}`;
      return Object.values(value).filter(Boolean).join(', ') || '';
    }

    if (typeof value === 'boolean') return value ? 'Yes' : 'No';

    return String(value);
  }

  isRouteLocationChangePreview() {
    const title = `${this.requestTitle || this.modalName || ''}`.toLowerCase();
    return title.includes('route location change');
  }

  initializeRoutePreviewForm() {
    if (!this.isRouteLocationChangePreview()) return;

    const transitModes = this.getTransitModeValues();
    this.routePreviewForm = this.fb.group({
      date: new FormControl(this.getDateValue()),
      location: new FormControl(this.getFieldInitialValue('location')),
      area: new FormControl(this.getFieldInitialValue('area')),
      message: new FormControl(this.getFieldInitialValue('message')),
      login: new FormControl(transitModes.includes('login')),
      logout: new FormControl(transitModes.includes('logout')),
    });
  }

  getPreviewFields() {
    const fields = Array.isArray(this.formPreviewFields)
      ? this.formPreviewFields.filter((field) => !!field?.label)
      : [];

    if (!this.isRouteLocationChangePreview()) return fields;

    const orderedKeys = ['date', 'location', 'transitMode', 'area', 'message'];
    return orderedKeys
      .map((key) => fields.find((field) => field?.name === key))
      .filter(Boolean);
  }

  getFieldPlaceholder(field: any) {
    if (!field) return '';
    return `${field.label || field.name}${field.required ? ' *' : ''}`;
  }

  isCheckboxField(field: any) {
    return field?.type === 'checkbox';
  }

  getFieldByName(name: string) {
    return Array.isArray(this.formPreviewFields)
      ? this.formPreviewFields.find((field) => field?.name === name)
      : null;
  }

  getFieldInitialValue(name: string) {
    const field = this.getFieldByName(name);
    return field ? this.getFieldValue(field) : '';
  }

  getDateValue() {
    const field = this.getFieldByName('date');
    if (!field?.value) return null;

    const date = new Date(field.value);
    return isNaN(date.getTime()) ? null : date;
  }

  getTransitModeValues(): string[] {
    const field = this.getFieldByName('transitMode');
    const rawValue = field?.value;

    if (Array.isArray(rawValue)) {
      return rawValue.map((item) => String(item).toLowerCase());
    }

    if (typeof rawValue === 'string') {
      return rawValue.split(',').map((item) => item.trim().toLowerCase()).filter(Boolean);
    }

    return [];
  }

  getStatusLabel(status: any) {
    const parsedStatus = +status;
    if (parsedStatus === 2) return 'In-progress';
    if (parsedStatus === 3) return 'Completed';
    if (parsedStatus === 4) return 'Rejected';
    return 'Pending';
  }

}
